import { CompType, expected, randomUUID } from '@aloft/toolkit-shared';
import { Image, Text, View } from '@react-pdf/renderer';

import { getCommentaryTableHelperText } from '../../../redux/features/selectors/utils/getCommentaryTableHelperText.ts';
import { COMMENTARY_TEXT, PNG_HEIGHT, PNG_WIDTH } from '../../commentary/consts.ts';
import { ExportChartContainer } from '../../commentary/export/ExportChartContainer.tsx';
import { CommentarySection } from '../components/CommentarySection.tsx';
import { Table } from '../components/Table.tsx';
import { Tkv2PDFPage } from '../components/Tkv2PDFPage.tsx';
import { fontStyles } from '../styles.ts';
import { SiteExtractionAdjustmentsPageProps } from '../types.ts';

export const SiteExtractionAdjustmentsPage = ({
  subjectAddress,
  adjustmentSettings,
  manualAdjustmentsEntities,
  commentaryV2,
  adjustmentsTableData,
  compSequence,
  compTypes,
  tkv2ChartImages: { siteSizeVsCostChartImage, siteSizeVsSiteValueChartImage },
}: SiteExtractionAdjustmentsPageProps) => {
  const { title, subtitle } = COMMENTARY_TEXT['site-extraction'];

  const tableData = adjustmentsTableData.siteExtraction;

  const helperText = getCommentaryTableHelperText(
    adjustmentSettings,
    'site',
    undefined,
    manualAdjustmentsEntities,
  );

  return (
    <Tkv2PDFPage title={title} address={subjectAddress}>
      <View style={{ display: 'flex', flexDirection: 'column', gap: 8, paddingBottom: 8 }}>
        <Text style={fontStyles.body}>{subtitle}</Text>

        <Table>
          {tableData[0].map((_, columnIndex) => (
            <Table.Column key={randomUUID()}>
              <Table.Cell compact>
                {tableData.map((row) => {
                  let compType: CompType | undefined;
                  const value = row[columnIndex];

                  if (columnIndex === 0 && value?.includes('CP')) {
                    const compNumber = Number(value.replace('CP', '').trim());
                    const compId = expected(compSequence[compNumber - 1]);
                    compType = compTypes[compId];
                  }

                  return (
                    <Table.CompTypeCell key={randomUUID()} compact compType={compType}>
                      {value}
                    </Table.CompTypeCell>
                  );
                })}
              </Table.Cell>
            </Table.Column>
          ))}
        </Table>
      </View>

      <Text style={fontStyles.small}>{helperText}</Text>
      {siteSizeVsSiteValueChartImage && (
        <ExportChartContainer title="Site Size vs Site Value">
          <Image
            src={siteSizeVsSiteValueChartImage}
            style={{ height: PNG_HEIGHT, width: PNG_WIDTH }}
          />
        </ExportChartContainer>
      )}
      {siteSizeVsCostChartImage && (
        <ExportChartContainer title="Site Size vs $/SF">
          <Image src={siteSizeVsCostChartImage} style={{ height: PNG_HEIGHT, width: PNG_WIDTH }} />
        </ExportChartContainer>
      )}
      <CommentarySection
        title="Site Commentary"
        commentary={commentaryV2.siteExtraction?.commentary}
      />
    </Tkv2PDFPage>
  );
};
